import { Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";
import IconGenerator from "../shared/IconGenerator";
import NxMarkdown from "../shared/NxMarkdown";
import RecapSummarySkeleton from "../skeleton/RecapSummarySkeleton";

const { Text } = Typography;

const Summary = ({
  summary,
  isLoading = false,
}: {
  summary?: string;
  isLoading?: boolean;
}) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <RecapSummarySkeleton />;
  }

  if (!summary?.trim()) {
    return null;
  }

  return (
    <Flex className="p-5 recap-summary-wrapper">
      <Flex vertical>
        <Flex align="center" gap={8}>
          <IconGenerator name={"SummaryIcon"} size={30} />
          <Text className="font-weight-500 h5">{t("recap.summary")}</Text>
        </Flex>

        <NxMarkdown text={summary} />
      </Flex>
    </Flex>
  );
};

export default Summary;
